module.exports = __webpack_public_path__ + "img/atletico-madrid.8047f500.png";